<template>
  <div class="tarja-twitter-wrapper">
    <!-- SVG Background -->
    <div class="tarja-bg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1920 1080"
        preserveAspectRatio="none"
        style="display: block; width: 100%; height: 100%"
      >
        <defs>
          <linearGradient
            id="bg-gradient-main"
            x1="-2.94"
            y1="539.27"
            x2="1919.64"
            y2="539.27"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#f5c5eb" />
            <stop offset="1" stop-color="#d73e4f" />
          </linearGradient>
          <linearGradient
            id="bg-gradient-left-circles"
            x1="-138.69"
            y1="322.67"
            x2="218.92"
            y2="322.67"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#fbfba3" />
            <stop offset=".7" stop-color="#7a63a2" />
            <stop offset="1" stop-color="#4f1593" />
          </linearGradient>
          <linearGradient
            id="bg-gradient-left-triangle"
            x1="307.48"
            y1="532.57"
            x2="307.48"
            y2="1071.37"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#1aa893" />
            <stop offset="1" stop-color="#eef7a2" />
          </linearGradient>
          <linearGradient
            id="bg-gradient-right-shape"
            x1="1578.38"
            y1="-0.24"
            x2="1578.38"
            y2="1015.55"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#542295" />
            <stop offset="1" stop-color="#f6f5a4" />
          </linearGradient>
          <linearGradient
            id="bg-gradient-header"
            x1="270.22"
            y1="199.13"
            x2="1647.43"
            y2="199.13"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#43af97" />
            <stop offset="1" stop-color="#a1d49e" />
          </linearGradient>
          <linearGradient
            id="bg-gradient-content"
            x1="1645.09"
            y1="610.64"
            x2="277.51"
            y2="610.64"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#43af97" />
            <stop offset="1" stop-color="#a1d49e" />
          </linearGradient>
        </defs>
        <!-- Main pink/red gradient background -->
        <rect
          fill="url(#bg-gradient-main)"
          x="-2.94"
          y="-1.45"
          width="1922.58"
          height="1081.45"
        />
        <!-- Left circles decoration -->
        <path
          fill="url(#bg-gradient-left-circles)"
          d="M160.84,431.41c35.7,32.69,58.08,79.67,58.08,131.89,0,98.75-80.05,178.81-178.8,178.81s-178.81-80.06-178.81-178.81c0-52.22,22.38-99.2,58.08-131.89-35.7-32.69-58.08-79.68-58.08-131.9,0-40.91,13.74-78.61,36.86-108.74-23.12-30.12-36.86-67.83-36.86-108.75,0-98.75,80.05-178.8,178.81-178.8S218.92-16.73,218.92,82.02c0,40.92-13.74,78.63-36.86,108.75,23.12,30.13,36.86,67.83,36.86,108.74,0,52.22-22.38,99.21-58.08,131.9h0Z"
        />
        <!-- Left bottom triangle -->
        <polygon
          fill="url(#bg-gradient-left-triangle)"
          points="90.06 531.07 -2.94 531.07 -2.94 1080 617.89 1080 90.06 531.07"
        />
        <!-- Right decorative shape -->
        <polygon
          fill="url(#bg-gradient-right-shape)"
          points="1647.43 -1.45 1920 -1.45 1920 604.76 1874.07 603.99 1873.58 808.41 1771.94 807.91 1772.44 1014.34 1236.75 1014.34 1236.75 873.3 1647.43 873.3 1647.43 -1.45"
        />
        <!-- Header bar (teal gradient) -->
        <rect
          fill="url(#bg-gradient-header)"
          x="270.22"
          y="137.28"
          width="1377.21"
          height="123.7"
        />
        <!-- Content area (teal gradient) -->
        <rect
          fill="url(#bg-gradient-content)"
          x="270.22"
          y="260.99"
          width="1377.21"
          height="699.31"
        />
        <!-- Avatar circle background (white) -->
        <circle fill="#fff" cx="359.54" cy="199.13" r="48.92" />
      </svg>
    </div>

    <!-- Content Overlay -->
    <div class="content-overlay">
      <!-- Card Container -->
      <div class="twitter-card">
        <!-- Header with Avatar and Name -->
        <div class="card-header">
          <!-- Avatar -->
          <div class="avatar-container">
            <img
              v-if="item.url_avatar_colaborador"
              :src="item.url_avatar_colaborador"
              :alt="item.dsc_nome_colaborador"
              class="avatar-image"
            />
            <div v-else class="avatar-placeholder">
              <v-avatar width="100" height="100">
                <v-img cover src="@/assets/User.png" alt="Avatar" />
              </v-avatar>
            </div>
          </div>
          <!-- Name -->
          <span class="username">{{ item.dsc_nome_colaborador }}</span>
        </div>

        <!-- Content Area -->
        <div class="card-content">
          <!-- Text Content -->
          <div v-if="isTextContent" class="text-content" :style="textContentStyle">
            {{ truncatedText }}
          </div>

          <!-- Image Content -->
          <div v-else-if="isImageContent" class="media-content">
            <img
              :src="item.url_midia_colaboracao"
              :alt="item.dsc_nome_colaborador"
              class="media-image"
            />
          </div>

          <!-- Video Content -->
          <div v-else-if="isVideoContent" class="media-content">
            <video
              ref="videoElement"
              :src="item.url_midia_colaboracao"
              class="media-video"
              autoplay
              muted
              loop
              playsinline
            />
          </div>

          <!-- Audio Content -->
          <div v-else-if="isAudioContent" class="audio-content">
            <div class="audio-player">
              <audio
                ref="audioElement"
                :src="item.url_midia_colaboracao"
                @loadedmetadata="onAudioLoaded"
                @timeupdate="onTimeUpdate"
                @ended="onAudioEnded"
                @canplay="onCanPlay"
                autoplay
                preload="auto"
                style="display: none"
              />

              <div class="audio-controls">
                <button class="play-pause-btn" @click="togglePlayPause">
                  <span class="play-icon">{{ isPlaying ? "❚❚" : "▶" }}</span>
                </button>

                <div class="wave-timeline-container" @click="seekAudio">
                  <div class="wave-timeline">
                    <div
                      v-for="i in 50"
                      :key="i"
                      class="wave-bar"
                      :style="getWaveBarStyle(i)"
                    ></div>
                  </div>
                </div>

                <button class="speed-btn" @click="togglePlaybackSpeed">
                  <span class="speed-text">{{ playbackSpeed }}x</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TarjaTwitterTelao",

  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        id: 1,
        dsc_nome_colaborador: "Username",
        dsc_texto_colaboracao: "",
        dsc_tipo_midia_colaboracao: null,
        url_midia_colaboracao: null,
        url_avatar_colaborador: null,
      }),
    },
    isFullScreen: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      playbackSpeed: 1,
      availableSpeeds: [1, 1.5, 2],
      autoplayAttempted: false,
    };
  },

  computed: {
    avatarInitial() {
      const name = this.item.dsc_nome_colaborador || "U";
      return name.charAt(0).toUpperCase();
    },

    truncatedText() {
      const text = this.item.dsc_texto_colaboracao || "";
      return text.length > 280 ? text.substring(0, 280) : text;
    },

    isTextContent() {
      return (
        !this.item.dsc_tipo_midia_colaboracao ||
        this.item.dsc_tipo_midia_colaboracao === "text"
      );
    },

    isImageContent() {
      return this.item.dsc_tipo_midia_colaboracao === "image";
    },

    isVideoContent() {
      return this.item.dsc_tipo_midia_colaboracao === "video";
    },

    isAudioContent() {
      return this.item.dsc_tipo_midia_colaboracao === "audio";
    },

    textContentStyle() {
      const text = this.item.dsc_texto_colaboracao || "";
      const numChars = Math.min(text.trim().length, 280);

      // Dynamic font sizing to fill the content box (1277px x ~620px usable area)
      // Scale from 72px (very short) down to 32px (280 chars)
      let fontSize;
      let lineHeight;

      if (numChars <= 50) {
        fontSize = "3.5rem";
        lineHeight = "5rem";
      } else if (numChars <= 80) {
        fontSize = "3.5rem";
        lineHeight = "4.5rem";
      } else if (numChars <= 120) {
        fontSize = "3.2rem";
        lineHeight = "4.5rem";
      } else if (numChars <= 160) {
        fontSize = "3rem";
        lineHeight = "4.3rem";
      } else if (numChars <= 200) {
        fontSize = "2.8rem";
        lineHeight = "4.2rem";
      } else if (numChars <= 240) {
        fontSize = "3rem";
        lineHeight = "4rem";
      } else {
        fontSize = "3px";
        lineHeight = "3rem";
      }

      return {
        fontSize,
        lineHeight,
      };
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.isAudioContent && this.$refs.audioElement) {
        this.attemptAutoplay();
      }
    });
  },

  methods: {
    async attemptAutoplay() {
      if (this.autoplayAttempted || !this.$refs.audioElement) return;

      this.autoplayAttempted = true;
      const audio = this.$refs.audioElement;

      try {
        await audio.play();
        this.isPlaying = true;
      } catch (error) {
        console.error("Autoplay prevented by browser:", error);
        this.isPlaying = false;
      }
    },

    togglePlayPause() {
      const audio = this.$refs.audioElement;
      if (this.isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      this.isPlaying = !this.isPlaying;
    },

    togglePlaybackSpeed() {
      const currentIndex = this.availableSpeeds.indexOf(this.playbackSpeed);
      const nextIndex = (currentIndex + 1) % this.availableSpeeds.length;
      this.playbackSpeed = this.availableSpeeds[nextIndex];

      if (this.$refs.audioElement) {
        this.$refs.audioElement.playbackRate = this.playbackSpeed;
      }
    },

    onAudioLoaded() {
      this.duration = this.$refs.audioElement.duration;
      this.$refs.audioElement.playbackRate = this.playbackSpeed;

      if (!this.autoplayAttempted) {
        this.attemptAutoplay();
      }
    },

    onCanPlay() {
      if (!this.autoplayAttempted) {
        this.attemptAutoplay();
      }
    },

    onTimeUpdate() {
      this.currentTime = this.$refs.audioElement.currentTime;
    },

    onAudioEnded() {
      this.isPlaying = false;
      this.currentTime = 0;
    },

    seekAudio(event) {
      const timeline = event.currentTarget;
      const rect = timeline.getBoundingClientRect();
      const percent = (event.clientX - rect.left) / rect.width;
      const seekTime = percent * this.duration;

      this.$refs.audioElement.currentTime = seekTime;
      this.currentTime = seekTime;
    },

    getWaveBarStyle(index) {
      const heights = [
        8,
        18,
        28,
        14,
        32,
        22,
        12,
        26,
        20,
        16,
        35,
        13,
        24,
        30,
        15,
        21,
        27,
        10,
        33,
        18,
      ];
      const height = heights[index % heights.length];

      const progressPercent =
        this.duration > 0 ? (this.currentTime / this.duration) * 100 : 0;
      const barProgress = (index / 50) * 100;
      const isActive = barProgress <= progressPercent;

      return {
        width: "4px",
        height: `${height}px`,
        backgroundColor: isActive ? "#1aa893" : "rgba(255, 255, 255, 0.6)",
        borderRadius: "2px",
        transition: "background-color 0.1s ease",
      };
    },
  },

  watch: {
    item: {
      handler() {
        this.autoplayAttempted = false;
        this.$nextTick(() => {
          if (this.isAudioContent && this.$refs.audioElement) {
            this.attemptAutoplay();
          }
        });
      },
      deep: true,
    },

    isAudioContent(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.$refs.audioElement) {
            this.attemptAutoplay();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Gobold Regular";
  src: url("@/assets/Gobold_Regular.otf") format("opentype");
}

@font-face {
  font-family: "Gobold Thin";
  src: url("@/assets/Gobold_Thin.otf") format("opentype");
}

.tarja-twitter-wrapper {
  //   position: fixed;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  pointer-events: none;
}

.tarja-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.content-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.twitter-card {
  position: relative;
  left: 270px;
  top: 110px;
  width: 1377px;
  height: 730px;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
}

.card-header {
  height: 124px;
  display: flex;
  align-items: center;
  padding: 0 40px;
  gap: 20px;
}

.avatar-container {
  width: 98px;
  height: 98px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #43af97 0%, #1aa893 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-initial {
  font-family: "Gobold Regular", "Arial Black", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: #fff;
}

.username {
  font-family: "Gobold Regular", "Arial Black", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-content {
  flex: 1;
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
  overflow: hidden;
}

.text-content {
  font-family: "Gobold Thin", "Arial Narrow", sans-serif;
  font-weight: 600;
  color: #fff;
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.media-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.media-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
}

.media-video {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
}

.audio-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.audio-player {
  width: 100%;
  max-width: 900px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 30px 40px;
}

.audio-controls {
  display: flex;
  align-items: center;
  gap: 24px;
}

.play-pause-btn {
  width: 60px;
  height: 60px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s ease, background 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  .play-icon {
    color: #fff;
    font-size: 20px;
    line-height: 1;
  }
}

.wave-timeline-container {
  flex: 1;
  cursor: pointer;
  padding: 12px 0;
}

.wave-timeline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  gap: 4px;
}

.wave-bar {
  flex-shrink: 0;
}

.speed-btn {
  width: 70px;
  height: 36px;
  border: none;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s ease, background 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }

  .speed-text {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    font-family: "Gobold Regular", sans-serif;
  }
}
</style>
